<template>
  <div id="organisation-events">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.areaMap.filter") }}</h5>
                <span>{{ $t("contentManagement.areaMap.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button
                    @click="
                      searchTerm = '';
                      isArchived = false;
                    "
                    icon="el-icon-refresh-right"
                    size="mini"
                    round
                  >
                    {{ $t("event.buttons.reset") }}
                  </el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="searchTerm" :placeholder="$t('placeholder.search')"></el-input>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <el-checkbox v-model="isArchived">{{ $t("organisation.event.showArchive") }}</el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("organisation.event.events") }}</h5>
              <span v-if="getEvents.length > 0" v-html="$t('totalContent', [getEvents.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-button round type="primary" size="mini" class="create-event-button" icon="fas fa-plus" @click="createDialog = !createDialog">{{ $t("organisation.event.createEvent") }}</el-button>
                <el-tooltip class="item" effect="dark" :content="$t('organisation.event.filter')" placement="top">
                  <el-button icon="fas fa-search" size="mini" @click="isFilterEnabled = !isFilterEnabled" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="getData" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="getEvents.length > 0">
            <div class="custom-grid-table-header ownevents-grid-template">
              <div>{{ $t("organisation.event.title") }}</div>
              <div>{{ $t("organisation.event.dateVenue") }}</div>
              <div></div>
            </div>
            <div class="list-group-o ownevents-container">
              <div class="item" v-for="item in getEvents" :key="item.id" :class="{ archive: item.isArchived }">
                <div class="img-title">
                  <div class="img" :style="'background-image:url(' + $imageus + item.logo + '?width=150&height=150&mode=cover)'"></div>
                  <div class="ownevents-item-title">{{ item.title }}</div>
                </div>
                <div class="table-date">
                  <div class="date">
                    <i class="fas fa-calendar"></i>
                    <span>{{ $moment(item.startDate).utc().format("DD MMM, YYYY - HH:mm") }}</span>
                    <i class="fas fa-arrow-right"></i>
                    <span>{{ $moment(item.endDate).utc().format("DD MMM, YYYY - HH:mm") }}</span>
                    <b></b>
                  </div>

                  <div class="venue" v-if="item.location.venue != null || item.location.city != null || item.location.country != null">
                    <i class="fas fa-map-marker-alt"></i>
                    <span>{{ (item.location.venue != null ? item.location.venue + " " : "") + (item.location.city != null ? item.location.city + ", " : "") + (item.location.country != null ? item.location.country : "") }}</span>
                  </div>
                </div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button type="primary" icon="fas fa-pen" circle size="mini" @click="switchEvent(item.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" v-if="!item.isArchived" :content="$t('eventCopy.copyEvent')" placement="top">
                    <el-button type="warning" icon="fas fa-copy" circle size="mini" @click="copyEvent(item.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="item.isArchived ? $t('eventCopy.unarchive') : $t('eventCopy.eventArchive')" placement="top">
                    <el-button type="success" icon="fas fa-file-archive" :loading="loading == 'archiveEvent-' + item.id" circle size="mini" @click="archiveEvent(item.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteEvent(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteEvent-' + item.id" circle size="mini" icon="fas fa-trash"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-events-v2-lottie'" :title="$t('organisation.event.events')" @btnAdd="false" @btnRefresh="getData" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
          </div>

          <div class="card-footer"></div>
          <el-dialog :title="copyEventObject.id != null && getEvents.find(x => x.id == copyEventObject.id) != null ? $t('eventCopy.eventCopyTitle', [getEvents.find(x => x.id == copyEventObject.id).title]) : $t('eventCopy.eventCopyTitle', ['Etkinlik'])" :visible.sync="copyDialog" class="medium" center modal-append-to-body destroy-on-close :before-close="clearCopyEvent">
            <div class="copyevent-dialog custom-modal">
              <div class="modal-body">
                <div class="copy-event-input">
                  <div class="copt-event-input-title">
                    <label>{{ $t("eventCopy.eventTitle") }}</label>
                  </div>
                  <el-input v-model="copyEventObject.title" size="medium" :placeholder="$t('enterEventName')"></el-input>
                  <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                </div>
                <div class="copy-event-input">
                  <div class="copt-event-input-title">
                    <label>{{ $t("eventCopy.eventCopyType") }}</label>

                    <span class="all-select" @click.stop="allSelect">{{ $t("eventCopy.selectAll") }}</span>
                  </div>
                  <el-checkbox-group @change="changeItems" class="copy-event-checkbox" v-if="getEnums != null" v-model="copyEventObject.items" :key="copyItemKey">
                    <el-checkbox
                      v-for="(option, index) in getEnums.find(x => x.title == 'EventCopyItem').enums"
                      :disabled="((option.key == 3 || option.key == 11) && copyEventObject.items.some(x => x == 4)) || ((option.key == 3 || option.key == 4 || option.key == 16 || option.key == 17) && copyEventObject.items.some(x => x == 5)) || ((option.key == 3 || option.key == 16 || option.key == 17) && copyEventObject.items.some(x => x == 14)) || (option.key == 3 && copyEventObject.items.some(x => x == 15 || x == 16 || x == 17))"
                      :label="option.key"
                      :key="index"
                    >
                      {{ option.displayName }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <span class="error">{{ $errorMessage("items", validationErrors) }}</span>
                </div>
              </div>
              <div class="modal-footer" slot="footer">
                <div class="left-buttons">
                  <el-button @click="clearCopyEvent">{{ $t("organisation.event.cancel") }}</el-button>
                </div>
                <div class="right-buttons">
                  <el-button type="primary" :loading="loading == 'createCopyEvent'" @click="createCopyEvent">{{ $t("organisation.event.create") }}</el-button>
                </div>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            :title="$t('createNewEvent')"
            :visible.sync="createDialog"
            class="medium"
            center
            modal-append-to-body
            destroy-on-close
            @close="
              title = null;
              validationErrors = [];
            "
          >
            <div id="createevent-dialog" class="custom-modal">
              <div class="modal-body">
                <el-input v-model="title" :class="$inputError('title', validationErrors)" size="medium" :placeholder="$t('enterEventName')"></el-input>
                <span class="error" v-if="$errorMessage('title', validationErrors)">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
              <div class="modal-footer" slot="footer">
                <div class="left-buttons">
                  <el-button @click="createDialog = false">{{ $t("organisation.event.cancel") }}</el-button>
                </div>
                <div class="right-buttons">
                  <el-button type="primary" :loading="loading == 'createEvent'" @click="createEvent">{{ $t("organisation.event.create") }}</el-button>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import slugify from "slugify";
import _ from "lodash";

import PageCountInfo from "../components/PageCountInfo";
import $ from "jquery";

export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.events")
    };
  },

  components: { PageCountInfo },
  name: "OrganisationEvents",

  data() {
    return {
      copyItemKey: +new Date(),
      copyDialog: false,
      copyEventObject: {
        id: null,
        title: null,
        items: []
      },
      createDialog: false,
      loading: false,
      title: null,
      search: false,
      showEventSelector: false,
      searchTerm: null,
      timeout: null,
      isFilterEnabled: false,
      validationErrors: [],
      isArchived: false
    };
  },

  methods: {
    allSelect() {
      if (this.getEnums.find(x => x.title == "EventCopyItem").enums != null && this.getEnums.find(x => x.title == "EventCopyItem").enums != undefined) {
        this.getEnums
          .find(x => x.title == "EventCopyItem")
          .enums.forEach(x => {
            if (!this.copyEventObject.items.some(y => y == x.key)) {
              this.copyEventObject.items.push(x.key);
            }
          });
        this.changeItems(this.copyEventObject.items);
      }
    },
    async createCopyEvent() {
      this.loading = "createCopyEvent";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("copyEvent", this.copyEventObject);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          await this.switchEvent(res.data.data.id);
        }
        this.loading = false;
      }, 500);
    },
    changeItems(newVal) {
      //Birbirine bağlı koşullar olduğu için bi 10 kere dönsün her döndüğünde tekrar itemleri kontrol etsin eksik bir şey kaldı mı diye
      for (let index = 0; index < 10; index++) {
        //Kayıt formu(4) kopyalanmak isteniyorsa segmentasyonda kopyalanmalı.
        if (newVal.some(x => x == 4)) {
          this.copyEventObject.items.push(3);
          this.copyEventObject.items.push(11);
        }

        //Katılımcılar(5) kopyalanmak isteniyor ise kayıt formları ve segmentasyon da kopyalanmalı.
        if (newVal.some(x => x == 5)) {
          //5
          this.copyEventObject.items.push(4); //4
          this.copyEventObject.items.push(3); //3
        }
        //Kontrol noktaları(14) kopyalanmak isteniyor ise,
        if (newVal.some(x => x == 14)) {
          this.copyEventObject.items.push(3); //3
          this.copyEventObject.items.push(16); //16
          this.copyEventObject.items.push(17); //17
        }
        //Promosyonlar(15) kopyalanmak isteniyor ise
        if (newVal.some(x => x == 15)) {
          this.copyEventObject.items.push(3); //3
        }

        //Alt etkinlikler(16) kopyalanmak isteniyor ise1
        if (newVal.some(x => x == 16)) {
          this.copyEventObject.items.push(3); //3
        }

        //Ek ürünler(17) kopyalanmak isteniyor ise
        if (newVal.some(x => x == 17)) {
          this.copyEventObject.items.push(3); //3
        }

        //Katılımcılar(5) kopyalanmak isteniyor ise
        if (newVal.some(x => x == 5)) {
          this.copyEventObject.items.push(4); // 4
          this.copyEventObject.items.push(16); // 16
          this.copyEventObject.items.push(17); // 17
          this.copyEventObject.items.push(3); // 3
        }
        this.copyEventObject.items = _.uniqWith(this.copyEventObject.items, _.isEqual);
        this.copyItemKey += 1;
      }
    },
    async getData() {
      this.loading = "loadingList";
      await this.$store.dispatch("getAuthorizedEvents");
      this.loading = false;
    },
    copyEvent(id) {
      this.copyEventObject.id = id;
      this.copyDialog = true;
    },
    archiveEvent(id) {
      this.loading = "archiveEvent-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("archiveEvent", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getAuthorizedEvents");
        }
        this.loading = false;
      }, 500);
    },
    deleteEvent(id) {
      this.loading = "deleteEvent-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteEvent", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getAuthorizedEvents");
          await this.$store.dispatch("getOrganizationList");
        }
        this.loading = false;
      }, 500);
    },
    clearCopyEvent() {
      this.copyEventObject = {
        id: null,
        title: null,
        items: []
      };
      this.copyDialog = false;
    },
    async switchEvent(id) {
      if ((this.timeout = null)) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/switchevent", { id });
        if (!res.data.alert.hasError) {
          this.eventWrapperLoading(true);
          axios.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
          this.$store.state.user.token = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          await this.$store.dispatch("getEvent");
          await this.$store.dispatch("getAuthorizedEvents");
          // await this.$store.dispatch("getPackets");
          await this.$store.dispatch("getSubEvents");
          await this.$store.dispatch("getGroups");
          await this.$store.dispatch("getTags");
          this.$router.push({ name: "event", params: { event_id: id } });
        }else {
          this.$message.error(res.data.alert.message);
        }
        this.eventWrapperLoading(false);
      }, 500);
    },
    async getOrganizationList(context) {
      var res = await axios.post("/Organization/GetAuthorizedOrganizations", {});

      if (!res.data.alert.hasError) {
        context.commit("setOrganizationList", res.data.data.organizations);
      } else {
        Message.error(res.data.alert.message);
      }
    },
    createEvent() {
      this.loading = "createEvent";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("createOrganizationEvent", this.title);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          await this.$store.dispatch("getOrganizationList");
          await this.$store.dispatch("getAuthorizedEvents");
          this.createDialog = false;
          await this.switchEvent(res.data.data.id);
        }
        this.loading = false;
      }, 500);
    },

    toogleExpand(row) {
      let $table = this.$refs.multipleTable;
      $table.toggleRowExpansion(row);
    },

    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSpeakerPage", page);
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      //return "row-passive";
      return "row-active";
    }
  },

  async created() {
    await this.$store.dispatch("getAuthorizedEvents");
  },

  computed: {
    skip() {
      return (this.$store.state.speakers.filter.page - 1) * this.$store.state.speakers.filter.take;
    },
    take() {
      return this.skip + this.$store.state.speakers.items.length;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    getSearchTerm() {
      return slugify(this.searchTerm == null ? "" : this.searchTerm, " ");
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    },
    getEvents() {
      var returnList = [];
      var regex = new RegExp(this.getSearchTerm, "g");
      if (this.getSearchTerm == null || this.getSearchTerm == "") {
        returnList = this.$store.state.event.events.filter(x => x.organizationID == this.currentOrganization.id);
      } else {
        returnList = this.$store.state.event.events.filter(k => k.organizationID == this.currentOrganization.id && (k.title.toLowerCase().match(regex) || k.title.match(regex) || k.searchTerms.some(x => x.toLowerCase().match(regex))));
      }

      if (this.isArchived) {
        return returnList.filter(x => x.isArchived == true || x.isArchived == false);
      } else {
        return returnList.filter(x => x.isArchived == false);
      }
    }
  },

  watch: {
    "$store.state.speakers.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSpeakers");
      }, 500);
    }
  }
};
</script>

<style lang="less">
#organisation-events {
  width: 100%;

  .ownevents-grid-template {
    grid-template-columns: 1.2fr 1fr 130px;
  }

  .ownevents-container {
    display: flex;
    flex-direction: column;
    .item {
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      grid-template-columns: 1.2fr 1fr 130px;

      &:last-child {
        margin-bottom: unset;
      }

      & > .action-btns {
        display: flex;
        flex-direction: row;
        gap: 0.3rem;
        .el-button {
          margin: 0;
        }
      }

      .table-date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .date,
        .venue {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span {
            color: #505763;
            font-size: 14px;
            font-weight: 500;
          }
          i {
            color: #06658c;
            margin-right: 4px;
            margin-left: 4px;
            font-size: 13px;
          }
          b {
            color: #06658c;
            margin-left: 4px;
          }
        }
      }

      .img-title {
        display: flex;
        gap: 1rem;
        font-weight: 500;
        align-items: center;

        & > .img {
          border-radius: 8px;
          width: 45px;
          height: 45px;
          background-size: cover !important;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
          background: white;
        }

        .ownevents-item-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
        }
      }

      transition: all 0.5s;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      background-color: #f1f1f1;

      &.passive {
        background-color: #fff2f2 !important;
      }
      &.archive {
        background-color: #ebdddd !important;
      }
      display: grid;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;

      & > .price-title {
        font-weight: bold;
        flex-direction: row;
        gap: 0.5rem;

        .el-input {
          width: 100%;
        }
      }

      .el-input-number {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }

      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
        &.me {
          color: #ccc;
        }
      }
      & > .title {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > i.el-icon-loading {
          font-size: 20px;
        }
      }

      & > div:last-child {
        justify-self: flex-end;
      }
      .table-icon {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: bold;
      }
    }
  }
  .copyevent-dialog {
    & > .modal-body {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .copy-event-input {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .copt-event-input-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .all-select {
          text-decoration: underline;
          cursor: pointer;
          font-weight: 500;
          color: #03658c;
        }
      }
      label {
        margin-bottom: 0;
        font-weight: bold;
      }
      .copy-event-checkbox {
        display: grid;
        grid-template-columns: 1fr 1fr;
        label {
          font-weight: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationEvents.vue